import React, { useCallback, useEffect, useState } from "react";
import {
  createContactsSession,
  getContactsSessionStatus,
} from "../../lib/api";

export const AdminSessionGate = ({ children }) => {
  const [access, setAccess] = useState("checking");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const checkSession = useCallback(async () => {
    try {
      const session = await getContactsSessionStatus();
      setAccess(session.authenticated ? "granted" : "login");
    } catch (requestError) {
      setAccess("login");
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const login = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await createContactsSession({ password });
      setPassword("");
      setAccess("granted");
    } catch (requestError) {
      setError("Contraseña incorrecta. Prueba otra vez.");
    } finally {
      setBusy(false);
    }
  };

  if (access === "checking") {
    return (
      <main className="max-w-[960px] mx-auto px-6 py-20">
        <div className="wk-skel" style={{ height: 200 }} data-testid="admin-session-loading" />
      </main>
    );
  }

  if (access === "granted") {
    return children;
  }

  return (
    <main className="max-w-[480px] mx-auto px-6 py-20">
      <div className="wk-card p-8" data-testid="admin-session-login-card">
        <div className="wk-eyebrow mb-4">Panel interno</div>
        <h1
          className="text-[28px] font-bold tracking-hero"
          style={{ color: "#1E1924" }}
          data-testid="admin-session-login-title"
        >
          Acceso protegido
        </h1>
        <form className="mt-7" onSubmit={login}>
          <label
            className="text-[13px] font-medium"
            style={{ color: "#1E1924" }}
            htmlFor="admin-session-password"
          >
            Contraseña
          </label>
          <input
            id="admin-session-password"
            type="password"
            className="wk-input mt-1.5"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            data-testid="admin-session-password-input"
          />
          {error ? (
            <p
              className="mt-3 text-[13px]"
              style={{ color: "#B42318" }}
              data-testid="admin-session-login-error"
            >
              {error}
            </p>
          ) : null}
          <button
            className="wk-btn wk-btn-primary mt-5"
            disabled={busy}
            data-testid="admin-session-login-button"
          >
            {busy ? "Comprobando…" : "Entrar"}
          </button>
        </form>
      </div>
    </main>
  );
};